import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0580d0dc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "TokensFalling__overlay"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "TokensFalling__container--transparent"
};
var _hoisted_3 = {
  "class": "Message__container"
};
var _hoisted_4 = {
  "class": "Message__title"
};
var _hoisted_5 = {
  "class": "Message__subtitle"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("video", {
    id: "myVideo",
    autoplay: "",
    muted: "",
    playsinline: "",
    "class": "TokensFalling__video"
  }, [/*#__PURE__*/_createElementVNode("source", {
    src: "assets/videos/stock/coins_dropping_animation.webm",
    type: "video/webm"
  }), /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")], -1);
});
var _hoisted_7 = {
  id: "myAudio"
};
var _hoisted_8 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$store.state.tokenScreenTitle), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, _toDisplayString(_ctx.$store.state.tokenScreenSubtitle1), 1), _createTextVNode(), _createElementVNode("div", null, _toDisplayString(_ctx.$store.state.tokenScreenQuantity) + " " + _toDisplayString(_ctx.$store.state.tokenScreenSubtitle2), 1)])]), _createElementVNode("button", {
    "class": "button",
    style: {
      "margin-top": "30px",
      "font-size": "24px",
      "background": "yellow",
      "color": "black"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateShowTokensFalling', false);
    })
  }, _toDisplayString(_ctx.$store.state.tokenScreenButtonText), 1), _hoisted_6]), _createElementVNode("audio", _hoisted_7, [_createElementVNode("source", {
    src: $data.AudioFileToPlay,
    type: "audio/mp3"
  }, null, 8, _hoisted_8), _createTextVNode(" Your system does not support the audio element. ")])]);
}